import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class SpecialtyVehicleBoatSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.actionAccent)}
            d="M20.488,74.085a14.347,14.347,0,0,0,4.136,5.282,9.989,9.989,0,0,0,6.3,2.241c8.168.052,32.006.518,43.59-1.99,1.21-.262,2.069-1.878,2.069-3.116h0Z"
          />
          <path
            className={css(styles.action)}
            d="M20.621,74.075l15.261-1.191,2.091-.186s5.256-.438,9.342-.384a13.117,13.117,0,0,1,5.327,1.208l.2.094,20.2,2.112,3.595.753S30.445,75.085,20.621,74.075Z"
          />
          <rect
            className={css(styles.actionAccent)}
            x="22.28"
            y="45.278"
            width="55.386"
            height="1.294"
            rx="0.642"
            transform="matrix(0.08, 0.997, -0.997, 0.08, 91.754, -7.561)"
          />
          <path
            className={css(styles.grey)}
            d="M33.858,81.681s10.1.106,13.845-1.765A12.058,12.058,0,0,1,59,79.979c3.573,1.872,4.807-1.169,8.039.192.843.355,2.775.418,6.955-1.4,2.489-1.084,3.987-1.777,5.105-.34,1.191,1.531-.553,3.148-.553,3.148Z"
          />
          <path
            className={css(styles.action)}
            d="M34.251,63.7c2.307-.534,7.1-1.025,15.73.48-5.591-27.454-2.572-41.3-2.572-41.3C42,29.53,36.608,52.581,34.251,63.7Z"
          />
          <path
            className={css(styles.action)}
            d="M50.17,65.079l-.007.04c-9.3-1.662-14.129-.962-16.118-.436-.657,3.136-1.03,5.111-1.03,5.111H51.2C50.828,68.177,50.489,66.612,50.17,65.079Z"
          />
          <path
            className={css(styles.grey)}
            d="M70.837,64c-6.09-8.79-17.53-26.143-20.532-36.572l3.476,36.826C55.606,64.364,65.213,64.9,70.837,64Z"
          />
          <path
            className={css(styles.grey)}
            d="M71.4,64.807a57.175,57.175,0,0,1-9.272.605c-3.719,0-7.068-.184-8.262-.258l.407,4.307H74.707S73.406,67.686,71.4,64.807Z"
          />
          <path
            className={css(styles.action)}
            d="M69.381,28.147a2.4,2.4,0,0,1-1.376,2.1,2.219,2.219,0,0,1-3.03-.677,2.2,2.2,0,0,1,1.183-2.86,2.443,2.443,0,0,1,2.412.022v-4.6l-6.207,1.888v6.205h0a2.4,2.4,0,0,1-1.375,2.1,2.217,2.217,0,0,1-3.031-.676,2.2,2.2,0,0,1,1.183-2.86,2.443,2.443,0,0,1,2.412.022V21.835l7.831-2.382v8.694Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M74.356,29.375c.846,1.567,3.9,1.906,1.918,5.464.141-2.093-.872-2.469-1.918-3.061v5.986h0a2.4,2.4,0,0,1-1.375,2.1,2.025,2.025,0,1,1-1.847-3.536,2.444,2.444,0,0,1,2.411.022V29.375Z"
          />
        </g>
      </svg>
    );
  }
}
